import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";

import { authApi } from "./services/auth";

import { usersApi } from "./services/users";
import authReducer from "./slices/authSlice";
import { suppliersApi } from "./services/suppliers";

const setUpStore = () => {
  const store = configureStore({
    reducer: {
      [authApi.reducerPath]: authApi.reducer,
      [usersApi.reducerPath]: usersApi.reducer,
      [suppliersApi.reducerPath]: suppliersApi.reducer,

      auth: authReducer,
    },
    middleware: (getDM) => [
      ...getDM(),
      authApi.middleware,
      usersApi.middleware,
      suppliersApi.middleware,
    ],
  });
  setupListeners(store.dispatch);
  return store;
};

export const store = setUpStore();
